import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', path: '/about-us' },
    { name: 'Ambassadors', path: '/our-ambassadors' },
    { name: 'Apply', path: '/apply' },
    { name: 'Join the Team', path: '/join-the-team' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-cream/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="px-6 py-4">
        <div className="max-w-7xl mx-auto relative">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link
              to="/"
              className="bg-dark-green text-cream px-6 py-3 rounded-full font-serif text-lg font-medium hover:bg-dark-green/90 transition-all duration-300 hover:scale-105"
            >
              Dharma Initiative
            </Link>

            {/* Desktop Navigation - Centered */}
            <div className="hidden lg:flex items-center gap-1 bg-dark-green rounded-full px-2 py-2 absolute left-1/2 -translate-x-1/2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-6 py-2 rounded-full transition-all duration-300 whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'bg-cream text-dark-green'
                      : 'text-cream hover:bg-cream/10'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* Login Button */}
            <div className="hidden lg:block">
              <a
                href="https://dharma-initiative.bettermode.io/auth/login?redirect=%2F"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-dark-green text-cream px-6 py-3 rounded-full font-medium hover:bg-dark-green/90 transition-all duration-300 hover:scale-105 whitespace-nowrap"
              >
                Log In
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden bg-dark-green text-cream p-2 rounded-full"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 bg-dark-green rounded-2xl p-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-xl transition-all duration-300 ${
                  location.pathname === link.path
                    ? 'bg-cream text-dark-green'
                    : 'text-cream hover:bg-cream/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://dharma-initiative.bettermode.io/auth/login?redirect=%2F"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 rounded-xl bg-cream text-dark-green text-center font-medium"
            >
              Log In
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
